import { NAMESPACE } from './constants';

export const INITIALIZE = `${NAMESPACE}/INITIALIZE`;
